<template>
  <div class="wrapper text-right">
    <img src="../../../../assets/logo_assobens.jpg">
  </div>
</template>

<script>

export default {
};
</script>
<style lang="scss" scoped>
.wrapper {
  background-color: #fff;
  height: 100vh;
}
</style>
